"use client"
import React, { useState, useEffect } from "react";
import Asset from "@/components/shared/Asset";
import MapLink from "@/components/shared/MapLink";
import PostGalleryView from "@/components/posts/PostGalleryView";
import UralityAvatarImage from "@/components/shared/UralityAvatarImage";
import { useConfig } from "@/lib/providers/ConfigProvider";
import { Container, Row, Col } from "react-bootstrap";
import moment from "moment";

import "@/components/posts/PostViewContainer.css";
import CollapsedHeader from "@/components/shared/CollapsedHeader";

const PostViewContainer = ({ name, profile, community, post }) => {
  const { webUrl } = useConfig();
  if (post) {
    return (
      <>
        <div className="post-view-container">
          <Container>
            <Row>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                {post.mapPoint.assets && post.mapPoint.assets.length > 0 && (
                  <Asset assets={post.mapPoint.assets} />
                )}
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="profile-landing-page-anchor-text-section border">
                  {post.mapPoint && post.mapPoint.title && (
                    <h2>{post.mapPoint.title}</h2>
                  )}
                  {post.mapPoint && post.mapPoint.location && (
                    <MapLink
                      className="profile-landing-page-content-location"
                      location={post.mapPoint.location}
                    />
                  )}
                  <div className="profile-landing-page-attribution">
                    <UralityAvatarImage
                      size="sm"
                      imageId={post.owner.logoId}
                      name={post.owner.displayName}
                      type={post.owner.userProfileType}
                    />
                    <span>
                      Created by{" "}
                      <a href={`${webUrl}${post.owner.resourceName}`}>
                        {post.owner.displayName}
                      </a>
                    </span>
                  </div>
                  <div style={{ marginTop: "0.5rem" }}>
                    <span>
                      Last modified{" "}
                      <b>
                        {moment(post.lastModifiedDate).format("MMMM D, yyyy")}
                      </b>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
            {post.mapPoint.text && (
              <Row className="post-view-text">
                <Col>
                  <p>{post.mapPoint.text}</p>
                </Col>
              </Row>
            )}
          </Container>

          <CollapsedHeader
            title={post.mapPoint.title}
            imageId={post.owner.logoId}
            name={post.owner.displayName}
            type={post.owner.userProfileType}
            rightCTA={<></>}
          />
          {post.type === "GALLERY" && (
            <PostGalleryView name={name} post={post} />
          )}
        </div>
      </>
    );
  } else {
    return <></>;
  }
};
export default PostViewContainer;
